export default "__VITE_ASSET__PMn9HpUb__"